/**
 * Utilidades de descarga de Cierre de Caja. La lógica genérica de descargas
 * autenticadas vive en src/utils/descargaAutenticada.js (compartida con
 * Cobranza Diaria y Expediente); aquí solo queda lo propio de este módulo.
 */
import { nombreArchivoPeriodo } from '../../utils/descargaAutenticada.js';

export {
  extensionPorTipo,
  limpiarParametros,
  mensajeErrorDescarga,
  validarArchivoDescargado
} from '../../utils/descargaAutenticada.js';

/**
 *   MIDAS_Cierre_Caja_2026-09-29.xlsx
 *   MIDAS_Cierre_Caja_2026-09-01_al_2026-09-30.pdf
 */
export function nombreArchivoCierre(tipo, fechaDesde, fechaHasta) {
  return nombreArchivoPeriodo('Cierre_Caja', tipo, fechaDesde, fechaHasta);
}
